// Recovered compiled webpack factory 80622. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "IconMark", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }),
    r(95155));
  let n = () => null;
}
